import { render, staticRenderFns } from "./TwoPhaseMethodSetting.vue?vue&type=template&id=7db846bf&scoped=true"
import script from "./TwoPhaseMethodSetting.vue?vue&type=script&lang=js"
export * from "./TwoPhaseMethodSetting.vue?vue&type=script&lang=js"
import style0 from "./TwoPhaseMethodSetting.vue?vue&type=style&index=0&id=7db846bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db846bf",
  null
  
)

export default component.exports